import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccessControlGatePlateDto } from '@shared/src/dtos/accesscontrol/gate/plate/AccessControlGatePlateDto';

@Component({
    selector: 'shared-forklift-right-actions',
    templateUrl: './shared.forklift.right.actions.component.html',
    styleUrls: ['./shared.forklift.right.actions.component.scss']
})
export class SharedForkliftRightActionsComponent {

    @Output() public refresh = new EventEmitter<boolean>();
    @Input() public value: AccessControlGatePlateDto | null = null;

}
